<script>
import Layout from "../../layouts/main";
import PageHeader from "../../components/page-header";
import flashMessage from "../../components/flashMessahe";
import VueSweetalert2 from "vue-sweetalert2";
import ErrorMessage from "../../components/error-message";
import {
  required,
  email,
  minLength,
  sameAs,
  maxLength,
  minValue,
  maxValue,
  numeric,
  url,
  alphaNum,
} from "vuelidate/lib/validators";

export default {
  components: {
      ErrorMessage,
    Layout,
    PageHeader,
    flashMessage,
  },
  data() {
    return {
      errorMessage: "",
      title: "Permission Create",
      items: [
        {
          text: "Permission",
          href: "/",
        },
        {
          text: "Create",
          active: true,
        },
      ],
      status: "not_accepted",
      checkCustom: "not_accepted",
      checked: true,
      errors: null,
        visible:false,
        message:"",
      form: {
        permission_name: "",
        permisssion_tag: "",
        permisssion_type: "",
        permisssion_category: "",
      },
      submitform: false,
      submitted: false,
    };
  },
  validations: {
    form: {
      permission_name: {
        required,
      },
      permisssion_tag: {
        required,
      },
      permisssion_type: {
        required,
      },
      permisssion_category: {
        required,
      },
    },
  },
  methods: {
      onClose(){
          this.visible=false;
      },
    formSubmit(event) {
      this.submitted = true;
      this.$v.$touch();
      axios
        .post("/api/permission_add", {
          name: this.form.permission_name,
          tag: this.form.permisssion_tag,
          type: this.form.permisssion_type,
          category: this.form.permisssion_category,
          accessToken: localStorage.getItem("access_tocken"),
        })
        .then((response) => {
          if (response.data.status) {
            this.$refs.permmissionForm.reset();
            this.$swal("Good job!", "Permission Created", "success");
            this.$router.push({ name: "all_permission" });
          } else {
            var str = response.data.message;
            var jsonParse = JSON.parse(str);
            this.errorCheck(jsonParse);
          }
        })
        .catch((error) => {
          if (error.response != undefined) {
            this.errors = error.response.data.errors;
          }
        });
    },
    errorCheck(obj) {
        if(obj.statusCode == 403){
            this.visible=true;
            this.message="Access Permission Denied";
            this.errors = obj.message;
        }else if (obj.error) {
        this.errors = obj.message;
      } else if (obj.message == "Token has expired") {
          this.$swal.fire({
              title: 'LogOut!',
              text: 'Token Has Expired',
              icon: 'error',
              toast:'true',
              position: 'top-end',
          });
        this.$router.push({ name: "logout" });
      } else if (
        obj.message !== "Token has expired" &&
        obj.message !== "The given data was invalid."
      ) {
        this.errors = obj.message;
      } else if (obj.message == "The given data was invalid.") {
        this.errors = obj.errors;
      } else {
        this.flashMessage.show({
          time: 5000,
          status: "error",
          title: "Error",
          message: "Problem in data save",
        });
      }
    },
    resetForm(event) {
      console.log("Reseting the form");
      event.target.reset();
    },
  },
};
</script>

<template>
  <Layout>
    <flashMessage/>
    <PageHeader :title="title" :items="items" />
      <ErrorMessage :visible="visible" :errors="errors" v-on:close="onClose" :message="message"/>
    <div class="row">
      <div class="col-lg-12 col-sm-12">
        <div class="card">
          <div class="card-body">
            <div v-if="errors" class="font-bold mb-4 ">
              <div v-for="(v, k) in errors" :key="k">
                <p v-for="error in v" :key="error" class="text-sm">
                  {{ error }}
                </p>
              </div>
            </div>
            <b-form class="needs-validation" ref="permmissionForm" @submit.prevent="formSubmit">
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group">
                    <label class="required" for="permission_name">Permission Name</label>
                    <input
                      id="permission_name"
                      v-model="form.permission_name"
                      name="permission_name"
                      type="text"
                      class="form-control"
                      placeholder="Type permission name"
                      value
                      :class="{ 'is-invalid': submitted && $v.form.permission_name.$error }"
                    />
                    <div
                      v-if="submitted && $v.form.permission_name.$error"
                      class="invalid-feedback"
                    >
                      <span v-if="!$v.form.permission_name.required">This value is required.</span>
                    </div>
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="form-group">
                    <label class="required" for="permisssion_tag">Permission Tag</label>
                    <input
                      id="permisssion_tag"
                      v-model="form.permisssion_tag"
                      name="permisssion_tag"
                      type="text"
                      class="form-control"
                      placeholder="Type permission tag"
                      value
                      :class="{ 'is-invalid': submitted && $v.form.permisssion_tag.$error }"
                    />
                    <div
                      v-if="submitted && $v.form.permisssion_tag.$error"
                      class="invalid-feedback"
                    >
                      <span v-if="!$v.form.permisssion_tag.required">This value is required.</span>
                    </div>
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="form-group">
                    <label class="required" for="permisssion_type">Permission Type</label>
                    <select
                      id="permisssion_type"
                      name="permisssion_type"
                      v-model="form.permisssion_type"
                      type="text"
                      class="form-control"
                      placeholder="Type permission type"
                      value
                      :class="{ 'is-invalid': submitted && $v.form.permisssion_type.$error }">
                        <option value="" disabled style="display:none" selected>Select Permission Type</option>
                      <option value="Admin">Admin</option>
                      <option value="B2B">B2B</option>
                      <option value="B2C">B2C</option>
                    </select>
                    <div
                      v-if="submitted && $v.form.permisssion_type.$error"
                      class="invalid-feedback"
                    >
                      <span v-if="!$v.form.permisssion_type.required">This value is required.</span>
                    </div>
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="form-group">
                    <label class="required" for="permisssion_category">Permission Category</label>
                    <input
                      id="permisssion_category"
                      v-model="form.permisssion_category"
                      name="permisssion_category"
                      type="text"
                      class="form-control"
                      placeholder="Type permission category"
                      value
                      :class="{ 'is-invalid': submitted && $v.form.permisssion_category.$error }"
                    />
                    <div
                      v-if="submitted && $v.form.permisssion_category.$error"
                      class="invalid-feedback"
                    >
                      <span v-if="!$v.form.permisssion_category.required">This value is required.</span>
                    </div>
                  </div>
                </div>
              </div>
              <button class="btn btn-primary" type="submit">Submit</button>
            </b-form>
          </div>
        </div>
        <!-- end card -->
      </div>
      <!-- end col -->
    </div>
    <!-- end row -->
  </Layout>
</template>
